export const getDisplayText = (value) => {
  if (value === 'NAN_SENTINEL' || value === null || value === undefined) {
    return '-';
  }

  return String(value);
};

export const getOptionLabel = ({ fallbackLabel, option }) => {
  return option?.title || option?.text || option?.value || fallbackLabel;
};

export const getQuestionOptionId = (option) => {
  return parseOptionId(option?.optionSourceId ?? option?.option_source_id ?? option?.id);
};

export const getThumbnailRegionId = ({ optionId, rowId }) =>
  `option-image-thumbnail-${optionId}-${String(rowId).replace(/[^a-zA-Z0-9_-]/g, '-')}`;

export const parseOptionId = (value) => {
  if (value === null || value === undefined || value === '') return null;

  const parsedValue = Number(value);
  if (!Number.isFinite(parsedValue)) return null;

  return parsedValue;
};
